export default __webpack_public_path__ + "static/media/fastener-placement-rectangle-rounded-top.e6d05da8.webp";